export const draftClientId = (draft, primaryContact)=>{
    var _ref, _draft_customerId;
    return (_ref = (_draft_customerId = draft.customerId()) !== null && _draft_customerId !== void 0 ? _draft_customerId : primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.customerId()) !== null && _ref !== void 0 ? _ref : null;
};
export const reviewersWithoutContact = (reviewers, contactId)=>contactId == null ? reviewers : reviewers.filter((reviewer)=>reviewer.clientContactId !== contactId);
